 import { DomainBase } from "./DomainBase";
 
 export  class ProductPos extends DomainBase {
    constructor() {
    super();
      
       
       this.ProdCode="";
       this.Description1="";
     this.ShortDescription=null;
     this.ShortName=null;
      this.CategoryID="00000000-0000-0000-0000-000000000000";
     this.SubGroupID="00000000-0000-0000-0000-000000000000";
     this.ItemTypeID="00000000-0000-0000-0000-000000000000";
      this.StockTypeID=0;
     this.RetailRate=0;
      this.WSRate=0;
       this.AvgCost=0;
       this.MinPrice=0;
      this.UnitID="00000000-0000-0000-0000-000000000000";
       this.ManufactureID="00000000-0000-0000-0000-000000000000";
       this.MinQty=0;
       this.ReorderLevel=0;
      this.MaxQty=0;
      this.ReorderQty=0;
      this.TaxID="00000000-0000-0000-0000-000000000000";
      this.TaxPercentage=0;
     this.IsMenuItem="";
       this.IsSalesTaxIncludedInPrice=false;
       this.IsPurchaseTaxIncludedInPrice=false;
       this.CreatedBy='';
       this.ModifiedDate=Date.now;
       this.Ubc="";
       this.Sbc=""
      this.image='';
      this.productImagesList=[];
      this. Branch =null;
      this.isActive=false;       
  }
}

